import _ from "lodash";
import Uuid from "../../../../support/Uuid";

class BaseComprobanteInputPipe {

  getName() {
    return 'comprobante';
  }

  apply(data) {
    if (!!data.Complemento) {
      delete data.Complemento.TimbreFiscalDigital;
    }

    delete data.Metadata;
    delete data.Idx;
    delete data.Serie;
    delete data.Folio;
    delete data.TipoDeComprobante;

    if (!!data.CfdiRelacionados) {
      data.Metadata = {
        cfdis_relacionados: true
      }
    }

    data.Conceptos.Concepto = data.Conceptos.Concepto.map((value) => {
      if (!!value.CuentaPredial) {
        value.CuentaPredial = _.map(value.CuentaPredial, (predial) => {
          predial.id = Uuid.v4();

          return predial;
        });
      }

      return {
        id: Uuid.v4(),
        ...value
      }
    });

    data.Fecha = undefined;
    data.FechaTemp = new Date();
    data.CfdiFecha = undefined;

    data.Receptor = {
      confirmed: true,
      ...data.Receptor,
      cp: data.Receptor.cp || data.Receptor.direccion?.cp
    };

    return data;
  }

}

export default BaseComprobanteInputPipe;